// extracted by mini-css-extract-plugin
export default {"inputElement":"LInput_inputElement__-AQZv","title":"LInput_title__fjnJv","inputNoMargin":"LInput_inputNoMargin__Yo2h1","disabledField":"LInput_disabledField__A2qwM"};